import React from 'react';
import RadioLabel from '../../../../common/radio/RadioLabel';
import { otherBankTypeInfoState } from '../../../../../data/estimate/common/otherBank/info/atom';
import { useRecoilValue } from 'recoil';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';
import useUpdateInfo from '../../../../../hooks/estimate/common/useUpdateInfo';
import useFetchOtherBank from '../../../../../hooks/estimate/common/fetch/useFetchOtherBank';

interface Props {
  type: number;
}

/**
 *  타금융사 할부 조건 구분 라디오 컴포넌트
 * @param {number} type 개인(1) or 법인(2)
 *  */
function OtherBankTypeRadio({ type }: Props): JSX.Element {
  // select
  const checked: number = useRecoilValue(otherBankInfoState({ name: 'otherBankType' }));

  // function
  const { updateOtherBankList } = useFetchOtherBank();
  const update = useUpdateInfo(otherBankTypeInfoState);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.checked) {
      update(type);
      updateOtherBankList({
        inputName: 'type',
        inputValue: type,
      });
    }
  };

  return (
    <RadioLabel
      name='condition-type'
      checked={checked === type}
      onChange={onChange}
      text={type === 1 ? '개인' : '법인'}
    />
  );
}

export default OtherBankTypeRadio;
